import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  DetailFormMain,
  UserAvatar,
  UserAvatarMian,
  DetailHeader,
  UserInfo,
  FormPart,
} from "./styles/DetailFormStyles";
// import CameraAltIcon from "@mui/icons-material/CameraAlt";
// import orderimg from "../../../assets/images/orderimg.png";
import MainButton from "../../shared/Button";
import AuthInput from "../../shared/authinput";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../shared/commonstyle/PhoneStyle";
import CommonPhoneInputs from "../../shared/authinput/CommonPhoneInputs";
import { isValidPhoneNumber } from "react-phone-number-input";
import { Customevalidation } from "../../../helpers/validations/admin/CustomerDetails";
import { UpdateCustomerStatus } from "../../../services/admin/customer";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";

const DetailForm = ({ AllData = [] }) => {
  const { id } = useParams();
  const [activeloading, setactiveLoading] = useState(false);
  const [userStatus, setuserStatus] = useState(null);
  const [inactiveloading, setinactiveLoading] = useState(false);

  useEffect(() => {
    if (AllData?.data?.user?.status) {
      setuserStatus(AllData?.data?.user?.status);
    }
  }, [AllData?.data?.user?.status]);

  const userName = AllData?.data?.user?.name || "";
  const initials = userName
    .split(" ")
    .map((name) => name.charAt(0))
    .join("");

  const handleChange = (value, event, form) => {
    // SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }
    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
  };

  const handleSubmit = (values) => {
    console.log("values", values);
  };

  const initialValues = {
    FirstName: AllData?.data?.user?.name || "",
    CompanyName: AllData?.data?.user?.company_name || "",
    email: AllData?.data?.user?.email || "",
    phoneNumber: AllData?.data?.user?.phone_number
      ? "+" + AllData?.data?.user?.phone_number
      : "",
    CustomerType: AllData?.data?.user?.user_type || "",
  };

  const HandelApproveUser = async () => {
    const res = await UpdateCustomerStatus(
      setactiveLoading,
      id,
      "active",
      "customers"
    );
    if (res.status === 200) {
      toast.success("Updated successfully");
      setuserStatus("active");
    }
  };
  const HandelRejectUser = async () => {
    const res = await UpdateCustomerStatus(
      setinactiveLoading,
      id,
      "inactive",
      "customers"
    );
    if (res.status === 200) {
      toast.success("Updated successfully");
      setuserStatus("inactive");
    }
  };

  return (
    <DetailFormMain>
      {AllData?.message === "Success" && (
        <>
          <DetailHeader>
            <UserAvatarMian>
              {AllData?.data?.user?.profile_image_url ? (
                <UserAvatar
                  alt="user image"
                  src={AllData?.data?.user?.profile_image_url}
                />
              ) : (
                <UserAvatar alt={userName}>{initials}</UserAvatar>
              )}
              {/* <CameraButton component="label" htmlFor="avatar-upload">
                <CameraAltIcon />
                <input
                  id="avatar-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageUpload}
                />
              </CameraButton> */}
            </UserAvatarMian>
            <UserInfo>
              <h6>{AllData?.data?.user?.name || ""}</h6>
              <p>
                {AllData?.data?.user?.phone_number
                  ? "+" + AllData?.data?.user?.phone_number
                  : ""}
              </p>
            </UserInfo>
          </DetailHeader>
          <FormPart>
            <Formik
              initialValues={initialValues}
              validationSchema={Customevalidation}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autocomplete="off">
                  <div className="FormItem">
                    <Field
                      type="text"
                      name="FirstName"
                      label="First Name"
                      component={AuthInput}
                      placeholder="Enter your First Name"
                      disabled
                    />
                  </div>
                  <div className="FormItem">
                    <Field
                      type="text"
                      name="CompanyName"
                      label="Company Name"
                      component={AuthInput}
                      placeholder="Enter your CompanyName"
                      disabled
                    />
                    <Field
                      type="email"
                      name="email"
                      label="Email Address"
                      component={AuthInput}
                      placeholder="Enter your Email Address"
                      disabled
                    />
                  </div>
                  <div className="FormItem havePhone">
                    <PhoneInputsMain
                      className={`PhoneInputsMain ${
                        formik.touched.phoneNumber &&
                        formik.errors.phoneNumber &&
                        "is__error"
                      }`}
                    >
                      <CustomLabel>Phone Number</CustomLabel>
                      <Field name="phoneNumber">
                        {({ field, form }) => (
                          <CommonPhoneInputs
                            {...field}
                            onChange={(value, event) =>
                              handleChange(value, event, form)
                            }
                            isDisable={true}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="phoneNumber"
                        component="span"
                        className="error"
                      />
                    </PhoneInputsMain>

                    <Field
                      type="text"
                      name="CustomerType"
                      label="Customer Type"
                      component={AuthInput}
                      placeholder="Enter Customer Type"
                      disabled
                    />
                  </div>

                  {userStatus && (
                    <div className="ButtonMain">
                      {userStatus === "pending" && (
                        <>
                          <MainButton
                            type="button"
                            label="Approve"
                            MT="80"
                            onClick={HandelApproveUser}
                            isLoading={activeloading}
                          />
                          <MainButton
                            type="button"
                            label="Reject"
                            MT="80"
                            border={true}
                            onClick={HandelRejectUser}
                            isLoading={inactiveloading}
                          />
                        </>
                      )}
                      {userStatus === "inactive" && (
                        <MainButton
                          type="button"
                          label="Approve"
                          MT="80"
                          onClick={HandelApproveUser}
                          isLoading={activeloading}
                        />
                      )}
                      {userStatus === "active" && (
                        <MainButton
                          type="button"
                          label="Reject"
                          MT="80"
                          border={true}
                          onClick={HandelRejectUser}
                          isLoading={inactiveloading}
                        />
                      )}
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </FormPart>
        </>
      )}
    </DetailFormMain>
  );
};

export default DetailForm;
